(function () {
  var loaded = false;
  var loading = false;
  var callbacks = [];

  function navTarget() {
    return document.querySelector('[data-navigation][data-megamenu-lazy="pending"]')
      || document.querySelector('#HeaderNavigation[data-megamenu-lazy="pending"]');
  }

  function runCallbacks() {
    while (callbacks.length) {
      var fn = callbacks.shift();
      try { fn(); } catch (e) { console.error(e); }
    }
  }

  function hydrateNav() {
    if (loaded) {
      runCallbacks();
      return Promise.resolve();
    }
    if (loading) {
      return new Promise(function (resolve) {
        callbacks.push(resolve);
      });
    }

    loading = true;
    var root = (window.routes && window.routes.root) ? window.routes.root : '';
    var url = root + '/search?view=ajax_mega_menu';

    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var source = wrap.querySelector('[data-navigation]');
        var target = navTarget();
        if (source && target && source.innerHTML.trim().length) {
          target.innerHTML = source.innerHTML;
          target.removeAttribute('data-megamenu-lazy');
          loaded = true;
          if (window.jQuery && window.halo && typeof window.halo.headerMasonry === 'function') {
            window.halo.headerMasonry();
          }
          document.dispatchEvent(new CustomEvent('megamenu:lazy-loaded'));
        }
      })
      .catch(function (err) {
        console.error('megamenu lazy load failed', err);
      })
      .finally(function () {
        loading = false;
        runCallbacks();
      });
  }

  function arm() {
    if (!navTarget()) {
      return;
    }

    var headerBottom = document.querySelector('.header-bottom');
    var primed = false;

    function prime() {
      if (primed) return;
      primed = true;
      hydrateNav();
    }

    if (headerBottom) {
      headerBottom.addEventListener('mousemove', prime, { passive: true, once: true });
      headerBottom.addEventListener('focusin', prime, { once: true });
    }

    document.querySelectorAll('.header__inline-menu .has-megamenu').forEach(function (item) {
      item.addEventListener('mouseenter', prime, { once: true });
      item.addEventListener('focusin', prime, { once: true });
    });

    document.querySelectorAll('[data-mobile-menu], [data-menu-mobile], .menu-toggle, .mobileMenu-toggle').forEach(function (btn) {
      btn.addEventListener('click', prime, { once: true });
      btn.addEventListener('touchstart', prime, { passive: true, once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();